export const VendorAuditDocumentInfo: any = [
    {
        id: 1,
        fileName: "Sampledocument1.doc"
    },
    {
        id: 2,
        fileName: "Sampledocument2.doc"
    },
    {
        id: 3,
        fileName: "Sampledocument3.doc"
    },
    {
        id: 4,
        fileName: "Sampledocument4.doc"
    }
]